import React from "react";
import { TableBody, TableRow, TableCell } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const cellStyle = {
  whiteSpace: "nowrap",
  borderRight: "1px solid #ddd",
  // textAlign: "center",
  py: 2,
  fontSize: "12px",
  width: "50%",
};
const cellIconStyle = {
  whiteSpace: "nowrap",
  borderRight: "1px solid #ddd",
  textAlign: "center",
  py: 0.5,
  fontSize: "12px",
  width: "50%",
};
const iconStyle = {
  cursor: "pointer",
  fontSize: "18px",
};

function UserManagementTableBody2({ filledRows, setTableData, tableData }) {
  const handleIconClick = (rowIndex, columnName) => {
    const updatedRows = [...tableData.rows];
    updatedRows[rowIndex][columnName] = !updatedRows[rowIndex][columnName];
    setTableData({ ...tableData, rows: updatedRows });
  };
  // const rows = Array.from(
  //   { length: 20 },
  //   (_, index) => filledRows?.[index] || null
  // );

  return (
    <>
      <TableBody>
        {filledRows?.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            <TableCell sx={cellStyle}>
              {row?.name || (
                <span style={{ visibility: "hidden" }}>Undefined</span>
              )}
            </TableCell>
            <TableCell sx={cellIconStyle}>
              {(row?.name && (
                <>
                  <PhoneIcon
                    style={{
                      ...iconStyle,
                      color: row?.powerPhone ? "#58A65C" : "#E4E4E4",
                      marginRight: "20%",
                    }}
                    onClick={() => handleIconClick(rowIndex, "powerPhone")}
                  />
                  <EmailIcon
                    style={{
                      ...iconStyle,
                      color: row?.powerMsg ? "#58A65C" : "#E4E4E4",
                    }}
                    onClick={() => handleIconClick(rowIndex, "powerMsg")}
                  />
                </>
              )) ||
                ""}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
}

export default UserManagementTableBody2;
